/* tslint:disable */
/* eslint-disable */
/**
 * Brandside Backend API
 * REST API бэкенда Brandside. Авторизация — Bearer-токен Laravel Passport (заголовок Authorization: Bearer token). Успешные ответы оборачиваются в конверт success_response — status: true, data: ...; ошибки — common_error_response — status: false, errors._common: сообщение.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime'
/**
 *
 * @export
 * @interface Logout200Response
 */
export interface Logout200Response {
  /**
   *
   * @type {boolean}
   * @memberof Logout200Response
   */
  status: boolean
}

/**
 * Check if a given object implements the Logout200Response interface.
 */
export function instanceOfLogout200Response(
  value: object
): value is Logout200Response {
  if (!('status' in value) || value['status'] === undefined) return false
  return true
}

export function Logout200ResponseFromJSON(json: any): Logout200Response {
  return Logout200ResponseFromJSONTyped(json, false)
}

export function Logout200ResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): Logout200Response {
  if (json == null) {
    return json
  }
  return {
    status: json['status'],
  }
}

export function Logout200ResponseToJSON(value?: Logout200Response | null): any {
  if (value == null) {
    return value
  }
  return {
    status: value['status'],
  }
}
